import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { translationChunksConfig } from '@spartacus/assets';
import {
  AuthGuard,
  CmsConfig,
  ConfigModule,
  I18nModule,
} from '@spartacus/core';
import { OutletPosition, provideOutlet } from '@spartacus/storefront';
import { NgCircleProgressModule } from 'ng-circle-progress';
import { SlickCarouselModule } from 'ngx-slick-carousel';
import { CustomCmsParagraphModule } from '../shared/modules/custom-cms-paragraph/custom-cms-paragrap.module';
import { FluDashboardBannerModule } from '../shared/modules/flu-dashboard-banner/flu-dashboard-banner.module';
import { OverviewBannerModule } from '../shared/modules/overview-banner/overview-banner.module';
import { QuickOrderModule } from '../shared/modules/quick-order/quick-order.module';
import { StatementsModule } from '../statements/statements.module';
import { AccOverviewPlaceholderComponent } from './account-overview/acc-overview-placeholder/acc-overview-placeholder.component';
import { AccOverviewPlaceholder1Component } from './account-overview/acc-overview-placeholder1/acc-overview-placeholder1.component';
import { AccountOverviewComponent } from './account-overview/account-overview.component';
import { FinancialsListComponent } from './account-overview/financials-list/financials-list.component';
import { FluContentComponent } from './account-overview/flu-content/flu-content.component';
import { LoaderComponent } from './account-overview/loader/loader.component';
import { MonograpWidgetComponent } from './account-overview/monograph-widget/monograph-widget.component';
import { NewsUpdatesComponent } from './account-overview/news-updates/news-updates.component';
import { OrderListComponent } from './account-overview/order-list/order-list.component';
import { OrderProductsComponent } from './account-overview/order-products/order-products.component';
import { SalestrackComponent } from './account-overview/salestrack/salestrack.component';
@NgModule({
  declarations: [
    AccountOverviewComponent,
    OrderListComponent,
    FinancialsListComponent,
    LoaderComponent,
    NewsUpdatesComponent,
    OrderProductsComponent,
    FluContentComponent,
    AccOverviewPlaceholderComponent,
    AccOverviewPlaceholder1Component,
    SalestrackComponent,
    MonograpWidgetComponent,
  ],
  imports: [
    CommonModule,
    I18nModule,
    OverviewBannerModule,
    FluDashboardBannerModule,
    RouterModule,
    SlickCarouselModule,
    StatementsModule,
    QuickOrderModule,
    NgbModule,
    FontAwesomeModule,
    CustomCmsParagraphModule,
    NgCircleProgressModule.forRoot({
      radius: 60,
      animateTitle: false,
      outerStrokeWidth: 13,
      innerStrokeWidth: 13,
      startFromZero: true,
      showInnerStroke: true,
      space: -13,
      subtitleFontSize: '28',
      subtitleFontWeight: '900',
      showTitle: false,
      showUnits: false,
      renderOnClick: false,
      animation: false,
      lazy: false,
    }),
    ConfigModule.withConfig({
      cmsComponents: {
        AccountOverviewFinancialsComponent: {
          component: AccountOverviewComponent,
          guards: [AuthGuard],
        },
        // AccountOverviewPlaceholderSlot: {
        //   component: AccOverviewPlaceholderComponent,
        // },
        // OpenInvoicePaymentReviewComponent: {
        //   component: PaymentReviewComponent,
        // },
        // AccountOpenInvoicePaymentComponent: {
        //   component: PaymentDetailsComponent,
        // },
        // OpenInvoicePaymentConfirmationComponent: {
        //   component: PaymentConfirmationComponent,
        // },
        // NewsAndUpdateComponent: {
        //   component: AccountOverviewComponent,
        // },
      },
      i18n: {
        backend: { loadPath: 'i18n-assets/{{lng}}/{{ns}}.json' },
      },
      chunks: translationChunksConfig,
    } as CmsConfig),
  ],
  providers: [
    provideOutlet({
      id: 'AccountOverviewPlaceholderSlot',
      position: OutletPosition.REPLACE,
      component: AccOverviewPlaceholderComponent,
    }),
    provideOutlet({
      id: 'AccountOverviewPlaceholderSlot2',
      position: OutletPosition.REPLACE,
      component: AccOverviewPlaceholder1Component,
    }),
    provideOutlet({
      id: 'AccountOverviewOrdersSlot',
      position: OutletPosition.REPLACE,
      component: AccountOverviewComponent,
    }),
    provideOutlet({
      id: 'AccountOverviewFinancialsSlot',
      position: OutletPosition.REPLACE,
      component: FinancialsListComponent,
    }),
    provideOutlet({
      id: 'SanofiAccountDashboardFluReservationsCMSSlot',
      position: OutletPosition.REPLACE,
      component: FluContentComponent,
    }),
  ],
})
export class AccountOverviewModule {}
